// 9fbef606107a605d69c0edbcd8029e5d
import { connect } from 'react-redux';
import {
  getIsBuyMorePromoEnabled,
  getCouponExpiryTimeDifference,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import OfferDetailsView from '../views/OfferDetails.view';
import {
  getPromoProducts,
  getCurrentCurrency,
  getPromotionsDetails,
} from './OfferDetails.selectors';
import { getOfferDetails, setOfferDetails } from './OfferDetails.actions';
import { fetchPromotionsDetails } from '../../Promotions/container/Promotions.action';

export const mapDispatchToProps = (dispatch) => {
  return {
    fetchPromoProducts: (payload) => {
      dispatch(getOfferDetails(payload));
    },
    setEligibleProducts: (payload) => {
      dispatch(setOfferDetails(payload));
    },
    fetchPromotionsDetails: (payload) => {
      dispatch(fetchPromotionsDetails(payload));
    },
  };
};

const mapStateToProps = (state) => {
  return {
    isBuyMorePromoEnabled: getIsBuyMorePromoEnabled(state),
    promoProducts: getPromoProducts(state),
    currency: getCurrentCurrency(state),
    promotionDetails: getPromotionsDetails(state),
    couponExpiryTimeDifference: getCouponExpiryTimeDifference(state),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OfferDetailsView);
